import { FC, useMemo, useEffect } from 'react';
import Header from './header';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';
import { Outlet } from 'react-router-dom';
import ActivityServiceProvider from '../../service_providers/activity_provider';
import { NotificationsContextProvider } from '@context/notifications_context';
import { useGlobalProvider } from '@hooks/helpers/useGlobalProvider';
import Footer from './footer';
import { useUserContext } from '@hooks/context/useUserContext';
import { useSupportChat } from '@hooks/helpers/useSupportChat';

interface IProps {
    className?: string;
}

const cx = classNames.bind(styles);
const GlobalProvider: FC<IProps> = ({ className }) => {
    const { user } = useUserContext();
    const rootStyles = useMemo(() => cx([styles.wrapper, className]), [className]);
    useGlobalProvider();
    useSupportChat(user);

    return (
        <ActivityServiceProvider>
            <NotificationsContextProvider>
                <div className={rootStyles}>
                    <div className={styles.content}>
                        <Header />
                        <Outlet />
                    </div>
                    <Footer />
                </div>
            </NotificationsContextProvider>
        </ActivityServiceProvider>
    );
};

export default GlobalProvider;
